import { Ajax } from '@bamboohr/utils';
import { OneOnOnesFeatureCheckResponse } from './types';

export const getOneOnOnesFeatureCheck = () =>
	Ajax.get<OneOnOnesFeatureCheckResponse>('/settings/one-on-ones/tools');
